import { Link } from "react-router-dom";
import { Phone, Mail, Clock, MapPin } from "lucide-react";
import { CONTACT, SERVICES, LOCATIONS, WHATSAPP_DEFAULT } from "@/data/content";
import { Logo } from "@/components/Navbar";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative bg-navy-dark text-slate-300 grain">
      <div className="mx-auto max-w-7xl px-4 sm:px-8 py-16 grid gap-12 md:grid-cols-4">
        <div className="space-y-4">
          <Logo dark />
          <p className="text-sm leading-relaxed text-slate-400">
            Australia-wide removalists for homes and businesses. Local, regional and interstate moves
            with transparent, written pricing, handled to perfection.
          </p>
          <p className="text-xs font-mono uppercase tracking-widest text-slate-500">ABN {CONTACT.abn}</p>
        </div>
        <div>
          <p className="mb-4 text-xs font-mono uppercase tracking-widest text-amber-500">Services</p>
          <ul className="space-y-2.5 text-sm">
            {SERVICES.map((s) => (
              <li key={s.slug}>
                <Link to={`/services/${s.slug}`} data-testid={`footer-service-${s.slug}`} className="hover:text-amber-400 transition-colors duration-150">{s.title}</Link>
              </li>
            ))}
            <li><Link to="/services" data-testid="footer-services-all" className="font-semibold text-amber-400">All Services →</Link></li>
          </ul>
        </div>
        <div>
          <p className="mb-4 text-xs font-mono uppercase tracking-widest text-amber-500">Areas We Service</p>
          <ul className="grid grid-cols-2 gap-x-4 gap-y-2.5 text-sm">
            {LOCATIONS.slice(0, 10).map((l) => (
              <li key={l.slug}>
                <Link to={`/areas/${l.slug}`} data-testid={`footer-area-${l.slug}`} className="hover:text-amber-400 transition-colors duration-150">{l.city}</Link>
              </li>
            ))}
            <li><Link to="/areas" data-testid="footer-areas-all" className="font-semibold text-amber-400">All Areas →</Link></li>
          </ul>
        </div>
        <div>
          <p className="mb-4 text-xs font-mono uppercase tracking-widest text-amber-500">Company</p>
          <ul className="space-y-2.5 text-sm">
            <li><Link to="/about" data-testid="footer-about-link" className="hover:text-amber-400 transition-colors duration-150">Why Choose Us</Link></li>
            <li><Link to="/quote" data-testid="footer-quote-link" className="hover:text-amber-400 transition-colors duration-150">Get a Quote</Link></li>
            <li><Link to="/contact" data-testid="footer-contact-link" className="hover:text-amber-400 transition-colors duration-150">Contact</Link></li>
            <li><Link to="/terms" data-testid="footer-terms-link" className="hover:text-amber-400 transition-colors duration-150">Terms &amp; Conditions</Link></li>
          </ul>
          <div className="mt-6 space-y-2.5 text-sm">
            <a href={`tel:${CONTACT.phonePrimaryRaw}`} data-testid="footer-phone-primary" className="flex items-center gap-2 hover:text-amber-400 transition-colors duration-150"><Phone className="h-4 w-4 text-amber-500" /> {CONTACT.phonePrimary}</a>
            <a href={`tel:${CONTACT.phoneMobileRaw}`} data-testid="footer-phone-mobile" className="flex items-center gap-2 hover:text-amber-400 transition-colors duration-150"><Phone className="h-4 w-4 text-amber-500" /> {CONTACT.phoneMobile}</a>
            <a href={`mailto:${CONTACT.email}`} data-testid="footer-email" className="flex items-center gap-2 hover:text-amber-400 transition-colors duration-150"><Mail className="h-4 w-4 text-amber-500" /> {CONTACT.email}</a>
            <a href={WHATSAPP_DEFAULT} target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp" className="flex items-center gap-2 hover:text-amber-400 transition-colors duration-150"><MapPin className="h-4 w-4 text-amber-500" /> WhatsApp click-to-chat</a>
            <p className="flex items-center gap-2 text-slate-400"><Clock className="h-4 w-4 text-amber-500" /> {CONTACT.hours}</p>
          </div>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="mx-auto flex max-w-7xl flex-col sm:flex-row items-center justify-between gap-3 px-4 sm:px-8 py-6 text-xs text-slate-500">
          <p>© {new Date().getFullYear()} NextMove Removalists. All rights reserved.</p>
          <p>Sydney · Melbourne · Brisbane · Perth · Adelaide · Canberra · Hobart · Darwin &amp; regional Australia</p>
        </div>
      </div>
    </footer>
  );
}
